import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import styles from './Loading.css';

const cx = classnames.bind(styles);

const renderMsg = (type, size, content) => (
  <p className={cx(
    size ? 'section-title' : 'hotspot-title',
    styles[type]
  )}>
    {content}
  </p>
);

const Loading = props => {
  const { title, msg, large, simple, dark } = props;

  return (
    <div className={cx(styles.container, { large, simple, dark })}>
      <svg className={styles.spinner} viewBox="0 0 44 44">
        <circle
          className={styles.path}
          cx="22"
          cy="22"
          r="20"
          fill="none"
          strokeWidth="2.2"
        />
      </svg>
      {renderMsg('title', large, title)}
      {!simple && renderMsg('msg', large, msg)}
    </div>
  );
};

Loading.displayName = 'Loading';

Loading.propTypes = {
  large: PropTypes.bool,
  dark: PropTypes.bool,
  title: PropTypes.string,
  msg: PropTypes.string,
  simple: PropTypes.bool
};

Loading.defaultProps = {
  title: 'Refreshing...',
  msg: 'Thank you for your patience.'
};

export default Loading;



// WEBPACK FOOTER //
// ./src/uis/elements/Loading/Loading.js